import { render } from "./CodeAction.vue?vue&type=template&id=0d06d81c"
import script from "./CodeAction.vue?vue&type=script&lang=js"
export * from "./CodeAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__